import { ICountry } from '@shared/models';
import {
  AscResponse,
  LoggedInUserInfo,
  MyAvatars,
  UserProfile,
  UserRanks,
  UserStats,
} from '../../models';
import { httpService } from '../../utilities';
import { UserEndpoints } from './user.endpoints';

export async function getLoggedInUserInfoApi() {
  return httpService
    .get<AscResponse<LoggedInUserInfo>>(UserEndpoints.getLoggedInUserInfo)
    .then((res) => res.data?.data);
}

export async function isUserAddedBySchool() {
  return httpService
    .get<AscResponse<{ isSchoolStudent?: boolean; isAddedByAdmin?: boolean }>>(
      UserEndpoints.checkUser
    )
    .then((res) => res.data?.data);
}

export async function getMyRanksApi() {
  return httpService
    .get<UserRanks>(UserEndpoints.getMyRanks)
    .then((res) => res.data);
}
export async function getMyCoinsCountApi() {
  return httpService
    .get<AscResponse<{ coinsBalance: number }>>(UserEndpoints.getMyCoinsCount)
    .then((res) => res.data?.data?.coinsBalance);
}
export async function getMyStatsApi() {
  return httpService
    .get<UserStats>(UserEndpoints.getMyStats)
    .then((res) => res.data);
}

export async function getAvatarsApi() {
  return httpService
    .get<MyAvatars>(UserEndpoints.getAvatars)
    .then((res) => res.data);
}

export async function changeAvatarApi(formData: FormData) {
  return httpService
    .patch<AscResponse<LoggedInUserInfo>>(
      UserEndpoints.changeAvatar,
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      }
    )
    .then((res) => res.data?.data);
}

export async function updateUserInfoApi(userInfo: UserProfile) {
  return httpService
    .patch<AscResponse<LoggedInUserInfo>>(
      UserEndpoints.updateUserInfo,
      userInfo
    )
    .then((res) => res.data?.data);
}

export async function changePasswordApi(
  changePasswordPayload: Record<'oldPassword' | 'newPassword', string>
) {
  return httpService
    .patch<
      AscResponse<{
        isPasswordChanged: boolean;
      }>
    >(UserEndpoints.changePassword, changePasswordPayload)
    .then((res) => res.data?.data);
}
export async function getMyBalanceApi() {
  return httpService
    .get<
      AscResponse<{
        coinsBalance: number;
      }>
    >(UserEndpoints.getMyBalance)
    .then((res) => res.data?.data);
}
export async function joinEventsApi() {
  return httpService
    .get<
      AscResponse<{
        coinsBalance: number;
      }>
    >(UserEndpoints.getMyBalance)
    .then((res) => res.data?.data);
}

export async function getCountriesListApi() {
  return httpService
    .get<AscResponse<ICountry[]>>(UserEndpoints.getCountriesList)
    .then((res) => res.data?.data);
}
export async function getBalanceApi() {
  return httpService.get(UserEndpoints.getBalance).then((res) => res?.data);
}
